import loadable from '@loadable/component';

export const SearchPage = loadable(/* #__LOADABLE__ */ () => import('./SearchPage'));
